import { render, staticRenderFns } from "./PoiInformation.vue?vue&type=template&id=6e2a7e96&"
import script from "./PoiInformation.vue?vue&type=script&lang=js&"
export * from "./PoiInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PoiInformation.vue"
export default component.exports